import { classNames } from '@fullstory/util/fmt';
import React from 'react';
import { identifyComponent } from '../../../util';
import css from './index.module.scss';
import { TableHeadBase as TableHeadBaseType } from './types';

export const TableHeadBase: TableHeadBaseType = ({
  children,
  className,
  variant = 'light',
  ...rest
}) => (
  <thead
    data-component="TableHeadBase"
    className={classNames(className, css[variant])}
    {...rest}
    {...identifyComponent('table-head-base', rest)}
  >
    {children}
  </thead>
);
